export const windowWatcher = () => {
  const body = document.querySelector("body");
  let currentScrollPosition = 0;

  const init = () => {
    bind();
  };

  const scrollHandler = scrollPosition => {
    if (isNaN(scrollPosition) || !body) {
      return;
    }

    if (isNaN(currentScrollPosition)) {
      currentScrollPosition = 0;
    }

    let scrollDirection = "down";

    if (scrollPosition < currentScrollPosition) {
      scrollDirection = "up";
    }

    body.dispatchEvent(
      new CustomEvent("window-watcher:scroll", {
        bubbles: true,
        cancelable: true,
        detail: {
          direction: scrollDirection,
          position: scrollPosition,
          scrolled: false
        }
      })
    );

    currentScrollPosition = scrollPosition;
  };

  const resizeHandler = () => {
    body.dispatchEvent(
      new CustomEvent("window-watcher:resize", {
        bubbles: true,
        cancelable: true
      })
    );
  };

  const bind = () => {
    let scrollThrottle = false;

    window.addEventListener("scroll", () => {
      if (scrollThrottle) {
        return;
      }

      scrollThrottle = true;
      scrollHandler(window.pageYOffset);

      setTimeout(() => {
        scrollThrottle = false;
        scrollHandler(window.pageYOffset);
      }, 96);
    });

    let resizeThrottle = false;

    window.addEventListener("resize", () => {
      if (resizeThrottle) {
        return;
      }

      resizeThrottle = true;
      resizeHandler();

      setTimeout(() => {
        resizeThrottle = false;
        resizeHandler();
      }, 240);
    });
  };

  init();
};
